module.exports = __webpack_public_path__ + "img/demandCard-bg.0522083.png";